import React, { useState } from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  FormControl,
  Typography,
  Tooltip,
  IconButton,
  Autocomplete,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import {
  CollapsedField,
  CustomInputLabel,
  CustomTextField,
} from '../restyled-mui/CustomInputs'

import HelpIcon from '@mui/icons-material/Help'
import { setSelectedUserSetup } from '../../redux/actions/userSetups'
import DateRangePicker from './DateRangePicker/DateRangePicker'

const useStyles = makeStyles(theme => ({
  formContainer: {
    backgroundColor: theme.palette.common.white,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 25px',
  },
  customSubtitle: {
    fontSize: 14,
    color: theme.palette.primary.main,
    // marginBottom: '20px',
  },
  tooltip: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    fontSize: theme.typography.fontSize,
  },
  arrow: {
    color: theme.palette.primary.main,
  },
  helpIcon: {
    color: theme.palette.primary.main,
  },
  tooltipContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '4px',
  },
}))

const PortfolioHistoryForm = props => {
  const classes = useStyles(props)
  const {
    selectedSetup,
    setSelectedUserSetup,
    userSetups,
    trackDisableStatus,
    selectedDateRange,
    setSelectedDateRange,
  } = props

  const isEmptyOrContainsUndefined =
    userSetups.length === 0 || userSetups.some(x => x === undefined)

  // Only one setup to pick from, so there is nothing to pick: show it as text.
  const isSingleSetup = userSetups.length === 1

  return (
    <div className={classes.formContainer}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Typography
            variant="h4"
            className={clsx(classes.formSubtitle, classes.customSubtitle)}
          >
            Setup selection
          </Typography>
          {!isEmptyOrContainsUndefined ? (
            <Grid container spacing={4}>
              <Grid item md={12}>
                {isSingleSetup ? (
                  <CollapsedField label="Setup Name" value={userSetups[0]} />
                ) : (
                  <>
                    <div className={classes.tooltipContainer}>
                      <CustomInputLabel>Setup Name</CustomInputLabel>
                      <Tooltip
                        title="You can search for a value by typing in the box!"
                        placement="top"
                        arrow
                        classes={{
                          tooltip: classes.tooltip,
                          arrow: classes.arrow,
                        }}
                      >
                        <span>
                          <IconButton
                            style={{ padding: '0' }}
                            aria-label="info"
                            disableTouchRipple
                          >
                            <HelpIcon
                              fontSize="small"
                              className={classes.helpIcon}
                            />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </div>
                    <FormControl fullWidth variant="outlined" size="small">
                      <Autocomplete
                        disabled={trackDisableStatus}
                        variant="outlined"
                        size="small"
                        options={userSetups}
                        value={selectedSetup}
                        autoHighlight
                        onChange={(_, newValue) => {
                          setSelectedUserSetup(newValue)
                        }}
                        renderInput={params => (
                          <CustomTextField
                            {...params}
                            inputProps={{
                              ...params.inputProps,
                              style: { padding: '1px 5px' },
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </>
                )}
              </Grid>
            </Grid>
          ) : (
            <CustomInputLabel>
              No available setup for selection or error occurred.
            </CustomInputLabel>
          )}
        </Grid>
        <Grid item md={12} className={classes.sectionDelimiter}>
          <Typography
            variant="h4"
            className={clsx(classes.formSubtitle, classes.customSubtitle)}
          >
            Date selection
          </Typography>
          <Grid container spacing={2} style={{ paddingBottom: '15px' }}>
            <DateRangePicker
              trackDisableStatus={trackDisableStatus}
              initialDateRange={selectedDateRange}
              onDateRangeChange={dateRange => {
                setSelectedDateRange(dateRange)
              }}
              // onErrorChange={setTimeDisableBtn}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    selectedSetup: state.userSetups.selectedSetup,
  }
}

const mapDispatchToProps = {
  setSelectedUserSetup,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PortfolioHistoryForm)
